import { render } from "./CasinoLiveComponentSidebar.vue?vue&type=template&id=045073f2&ts=true"
import script from "./CasinoLiveComponentSidebar.vue?vue&type=script&lang=ts"
export * from "./CasinoLiveComponentSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__